import { useTranslation } from 'react-i18next';
import { RUTA_IMATGES, rutaPagina } from '../Compartido/contenidoCamprodon.js';

// Xarxes de l'hotel (les del disseny) si la web no en té de configurades.
const FACEBOOK = "https://www.facebook.com/hotelcamprodon/";
const INSTAGRAM = "https://www.instagram.com/hotelcamprodon/";

// Franja del newsletter + xarxes socials, just abans del peu. El formulari
// envia el correu a la pàgina de newsletter de la web de l'hotel.
const Newsletter = ({ lang, config }) => {

    const { t } = useTranslation();

    const facebook = config.url_facebook || FACEBOOK;
    const instagram = config.url_instagram || INSTAGRAM;

    return (
        <div className="c-footer-newsletter o-container">
            <div className="c-footer-newsletter__inner">
                <span className="c-footer-newsletter__title text-uppercase">{t("Regístrate al newsletter para recibir ofertas especiales")}</span>
                <form action={rutaPagina("newsletter", lang)} method="GET" className="c-newsletter position-relative">
                    <input type="email" name="email" placeholder={t("Email")} className="c-newsletter__input" aria-label="Email" required />
                    <button type="submit" className="c-newsletter__button text-uppercase">{t("Suscribirse")}</button>
                </form>
                <nav>
                    <ul className="c-social-media-list list-style-none m-0 p-0">
                        {facebook && (
                            <li className="c-social-media-list__item">
                                <a href={facebook} className="c-social-media" rel="noreferrer noopener" target="_blank" aria-label="facebook">
                                    <svg aria-hidden="true" focusable="false" className="c-icon" width="43" height="43">
                                        <use href={RUTA_IMATGES + "icons-sprite.svg#sprite-icon-ico-facebook"}></use>
                                    </svg>
                                </a>
                            </li>
                        )}
                        {instagram && (
                            <li className="c-social-media-list__item">
                                <a href={instagram} className="c-social-media" rel="noreferrer noopener" target="_blank" aria-label="instagram">
                                    <svg aria-hidden="true" focusable="false" className="c-icon" width="43" height="43">
                                        <use href={RUTA_IMATGES + "icons-sprite.svg#sprite-icon-ico-instagram"}></use>
                                    </svg>
                                </a>
                            </li>
                        )}
                        {config.url_twitter && (
                            <li className="c-social-media-list__item">
                                <a href={config.url_twitter} className="c-social-media" rel="noreferrer noopener" target="_blank" aria-label="twitter">
                                    <svg aria-hidden="true" focusable="false" className="c-icon" width="43" height="43">
                                        <use href={RUTA_IMATGES + "icons-sprite.svg#sprite-icon-ico-twitter"}></use>
                                    </svg>
                                </a>
                            </li>
                        )}
                    </ul>
                </nav>
            </div>
        </div>
    );
};

export default Newsletter;
